import demo from './demo.js';
import docs from './docs.js';

const languageRegex = process.env.VUE_APP_LANGUAGE_CODES.split(',').join('|');

const routes = [
  ...demo,
  ...docs,
  {
    path: `/:lang(${languageRegex})?/`,
    name: 'notfound',
    component: () => import(/* webpackChunkName: "notfound" */ '@/views/NotFound.vue'),
  },
];

export default routes;
